import {
  DomainId,
  RequestAction,
  RequestSource,
  TrustBox,
} from '@domgen/dgx-fe-common';
import { LightstepDeploymentEnvironment } from '@domgen/dgx-fe-lightstep';
import { APP_CMS_COMPONENT_MAPPING } from '../constants/cms-component-mapping.constant';
import { AppBuildConfig } from '../../app/models/build/app-build-config.interface';

export const buildConfig: AppBuildConfig = {
  buildFeatures: {},
  cms: {
    cmsRootPath: 'gb/domestic-and-general/self-fix',
    brandContentAppRootPath: 'gb',
    brandPrivacyPolicy: false,
    brandTermsAndConditions: false,
    componentMapping: APP_CMS_COMPONENT_MAPPING,
    cmsApi: 'https://author.prod.domesticgeneral.magnolia-platform.io',
  },
  defaultDomainId: DomainId.DomesticAndGeneral,
  domainIdMapping: {},
  lightstep: {
    collectorUrl: 'https://ingest.lightstep.com/traces/otlp/v0.9',
    debug: false,
    deploymentEnvironment: LightstepDeploymentEnvironment.Development,
    serviceName: 'dg-smart-fix-hub',
    serviceVersion: '1.0.0',
    traceHeaderWhitelist: [],
  },
  trustpilot: {
    businessUnitId: '4cb3113600006400050dfb02',
    templates: [
      { id: '5419b6ffb0d04a076446a9af', name: TrustBox.Micro },
      { id: '54ad5defc6454f065c28af8b', name: TrustBox.Slider },
    ],
  },
  requestAction: RequestAction.QuoteAndBuy,
  whiteLabelClient: RequestSource.DomesticAndGeneralUK,
};
